import React from 'react';
import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';
import { Spin } from 'antd';
import './GlobalLoader.scss';

const GlobalLoader = () => {
  const { isLoading, loadingMessage, showOverlay } = useSelector(state => state.globalLoader);

  if (!isLoading) return null;

  return createPortal(
    <div className={`global-loader ${isLoading ? 'with-overlay' : 'without-overlay'}`}>
      {showOverlay && <div className="loader-overlay" />}
      <div className="loader-content">
        <div className="loader-spinner">
          <Spin size="large" />
        </div>
        {/* {loadingMessage && (
          <div className="loader-message">
            {loadingMessage}
          </div>
        )} */}
      </div>
    </div>,
    document.body
  );
};

export default GlobalLoader;
